export const environment = {
  production: true,
  apiBaseUrl: "https://guide-backend.mak.at",
  graphQlEndpoint: "https://guide-backend.mak.at/graphql",
  templateUrl: "https://guide-backend.mak.at/wp-content/themes/mak/",
  applicationBaseUrl: "https://guide.mak.at"
};
